<template>
    <div class="row">
        <vueper-slides
            class="no-shadow"
            ref="myVueperSlidesMultiple"
            :visible-slides="3"
            slide-multiple
            :gap="2"
            :slide-ratio="1 / 4"
            :arrows="false"
            :bullets="false"
            :dragging-distance="200"
            :breakpoints="{
                1024: {
                    visibleSlides: 2,
                    slideMultiple: 2,
                    gap: '2'
                },
                800: {
                    visibleSlides: 1,
                    slideMultiple: 1
                }
            }"
        >
            <vueper-slide
                v-for="(slide, i) in getTestimonials"
                :key="i"
                :title="
                    '<b>' +
                        slide.customer_name +
                        '</b></br>' +
                        slide.customer_business
                "
                :content="slide.testimonial"
            />
        </vueper-slides>
    </div>
</template>

<script>
import { VueperSlides, VueperSlide } from "vueperslides";
import "vueperslides/dist/vueperslides.css";

import { mapGetters } from "vuex";
import { mapActions } from "vuex";

export default {
    name: "testimonial-advertise",
    components: { VueperSlides, VueperSlide },
    data() {
        return {};
    },
    mounted() {
        this.setTestimonials();
    },
    methods: {
        ...mapActions(["setTestimonials"])
    },
    computed: {
        ...mapGetters(["getTestimonials"])
    }
};
</script>

<style scoped>
.vueperslide {
    border-radius: 8px;
    padding: 10px 20px;
    box-shadow: 0px 0px 5px 5px rgba(3, 77, 118, 0.11);
    font-size: 14px;
    text-align: justify;
}
</style>
